// Planilhas de visitas (visitas_domiciliares): cada upload guarda TODAS as linhas da
// planilha — 20 uploads somam ~40 MB. Por isso as listas buscam só os dados de
// identificação (leve) e as linhas são baixadas só dos uploads que vão ser usados.
//
// Consolidado = importação automática do FTP da IW (sem especialidade) ou upload
// manual "Geral": todas as especialidades num upload só. Usado para montar um card
// por especialidade no painel e para abrir o detalhe de cada uma.
import { supabase } from './supabase';
import { grupoDe } from './visitasGrupos';

const TABELA = 'visitas_domiciliares';

export function dataDoUpload(raw) {
  if (!raw) return null;
  if (typeof raw?.toDate === 'function') return raw.toDate();
  if (typeof raw === 'object' && raw.seconds) return new Date(raw.seconds * 1000);
  const d = new Date(raw);
  return isNaN(d) ? null : d;
}

// Upload com todas as especialidades: sem especialidade (FTP automático) ou enviado como "Geral".
export function ehConsolidado(upload) {
  return !upload?.especialidade || upload.especialidade === 'Geral';
}

export function especialidadeDaLinha(r) {
  return String(r['Cod. Especialidade'] || r['Especialidade'] || '').trim() || '(sem especialidade)';
}

/** Lista de uploads, mais recentes primeiro, SEM as linhas (só identificação). */
export async function listarUploads(max = 80) {
  const { data, error } = await supabase
    .from(TABELA)
    .select('id, especialidade:data->>especialidade, uploadedAt:data->uploadedAt, fileName:data->>fileName, rowCount:data->>rowCount, uploadedBy:data->>uploadedBy, dataReferencia:data->>dataReferencia')
    .order('created_at', { ascending: false })
    .limit(max);
  if (error) throw new Error(error.message);
  return (data || [])
    .map(u => ({ ...u, rowCount: Number(u.rowCount) || 0 }))
    .sort((a, b) => (dataDoUpload(b.uploadedAt) || 0) - (dataDoUpload(a.uploadedAt) || 0));
}

/** Upload completo (com as linhas) pelo id. */
export async function carregarUpload(id) {
  const { data, error } = await supabase.from(TABELA).select('id, data').eq('id', id).maybeSingle();
  if (error) throw new Error(error.message);
  return data ? { id: data.id, ...data.data } : null;
}

/** Upload consolidado mais recente (com as linhas), ou null. */
export async function ultimoConsolidado() {
  const lista = await listarUploads(60);
  const meta = lista.find(ehConsolidado);
  return meta ? carregarUpload(meta.id) : null;
}

/** Linhas do consolidado que pertencem a uma especialidade (ou família: Fisioterapia, Fonoaudiologia...). */
export function linhasDaEspecialidade(consolidado, especialidade) {
  return (consolidado?.data || []).filter(r => grupoDe(especialidadeDaLinha(r)) === especialidade);
}
